
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 113.409 9.555"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{attrs:{"y":"123.17","x":"45.359","font-weight":"400","font-size":"10.583","font-family":"Open Sans","transform":"translate(-45.36 -113.718)"}},[_v('ANGEHÖRIGENDIALOG')])])
          )
        }
      }
    